import { useContext, useEffect, useRef, useState } from "react";
import {
  IonItem,
  IonLabel,
  IonLoading,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";
import { getUserSetups } from "../api/UserSetups";
import {
  saveEamSetting,
  useSaveErrorToast,
} from "../pages/settings/settingsShared";
import { getLanguageList } from "../api/Languages";
import {
  TranslationMessagesContext,
  TranslationsContext,
  getTranslatedMessages,
  getTranslations,
} from "../util/Translations";

const Languages: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
  const { translations, setTranslations } = useContext(TranslationsContext);
  const { setTranslatedMessages } = useContext(TranslationMessagesContext);
  const [languageList, setLanguageList] = useState<string[]>([]);
  const [currentLanguage, setCurrentLanguage] = useState<string>("");
  const [showLoading, setShowLoading] = useState(false);
  const showSaveError = useSaveErrorToast();
  const savedLanguage = useRef<string>("");

  const getLanguages = async () => {
    getLanguageList().then((response) => {
      Array.isArray(response.data) && setLanguageList(response.data);
    });
  };

  const setLanguage = async () => {
    const httpParams = {
      userSection: "options",
      userParameter: "language",
    };
    getUserSetups(httpParams).then((response) => {
      savedLanguage.current = response.data?.UserValue ?? "";
      setCurrentLanguage(response.data?.UserValue);
    });
  };

  const saveLanguage = async (lang: string) => {
    setCurrentLanguage(lang);
    setShowLoading(true);
    const saved = await saveEamSetting(
      "options",
      "language",
      lang === "" ? "American English" : lang
    );
    if (!saved) {
      setShowLoading(false);
      setCurrentLanguage(savedLanguage.current);
      showSaveError();
      return;
    }
    savedLanguage.current = lang;
    await saveTranslations();
    setShowLoading(false);
  };

  const saveTranslations = async () => {
    const translations = await getTranslations();
    setTranslations && setTranslations(translations);
    const translatedMessages = await getTranslatedMessages();
    setTranslatedMessages && setTranslatedMessages(translatedMessages);
  };

  useEffect(() => {
    setShowLoading(true);
    Promise.all([setLanguage(), getLanguages()]).finally(() => {
      setShowLoading(false);
    });
  }, []);

  return (
    <>
      <IonLoading
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        duration={5000}
      />
      <IonItem>
        <IonLabel position="stacked">
          {translations["lbl_language"] || "Language"}
        </IonLabel>
        <IonSelect
          interface="alert"
          placeholder={translations["lbl_btn_select"] || "Select"}
          value={currentLanguage}
          disabled={disabled}
          onIonChange={(ev) => {
            if (
              ev.detail.value &&
              ev.detail.value !== savedLanguage.current &&
              languageList.includes(ev.detail.value)
            ) {
              saveLanguage(ev.detail.value);
            }
          }}
        >
          {languageList.map((lang, index) => {
            return (
              <IonSelectOption key={`${index}-${lang}`}>{lang}</IonSelectOption>
            );
          })}
        </IonSelect>
      </IonItem>
    </>
  );
};
export default Languages;
